// import aftersalesReplayList from './list'
const addbanner = {
  path: 'advertising/addbanner',
  component: resolve => require(['@/pages/admin/platform/advertising/addbanner'], resolve),
  meta: {
    requireAuth: true
  },
  children: [
    // aftersalesReplayList,
  ]
}

export default addbanner
